import Rebase from 're-base';

const base = Rebase.createClass({
    apiKey: "AIzaSyALP8RaVIJavaf-78qOvBQecZgSXVee4E8",
    authDomain: "qcnitw-website.firebaseapp.com",
    databaseURL: "https://qcnitw-website.firebaseio.com",
    projectId: "qcnitw-website",
    storageBucket: "qcnitw-website.appspot.com",
    messagingSenderId: "905775210411"
});

export default base;



// WEBPACK FOOTER //
// ./src/components/base.js